import type * as React from "react";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { COLORS } from "components/v3/Theme/colors";

type RouterLinkTo = React.ComponentProps<typeof RouterLink>["to"];

export type AccountExitLinkProps = {
  to: RouterLinkTo;
  label?: React.ReactNode;
  sx?: SxProps<Theme>;
};

const AccountExitLink: React.FC<AccountExitLinkProps> = ({
  to,
  label = "← Exit",
  sx
}) => (
  <Box
    component={RouterLink}
    to={to}
    sx={{
      color: COLORS.DARK_GRAY,
      textDecoration: "none",
      width: "fit-content",
      "&:hover": {
        color: COLORS.DARK_GRAY,
        "& .MuiTypography-root": {
          color: COLORS.DARK_GRAY
        }
      },
      ...sx
    }}
  >
    <Typography variant="body_strong_dark_gray" component="span">
      {label}
    </Typography>
  </Box>
);

export default AccountExitLink;
